import { SxProps, Theme } from "@mui/material";
import { settingsReportStyles } from "./SettingsReport.styles";

// Client name clickable styles
export const clientNameClickableStyles: SxProps<Theme> = {
  ...settingsReportStyles.value,
  cursor: "pointer",
  textDecoration: "underline",
  "&:hover": {
    color: "#2C8BB0",
  },
};

export const clientNameDisabledStyles: SxProps<Theme> = {
  ...settingsReportStyles.value,
  color: "text.disabled",
  cursor: "not-allowed",
};

// Picker card styles
export const pickerCardStyles: SxProps<Theme> = {
  mt: 1,
  mb: 2,
  boxShadow: 3,
  borderRadius: 2,
};

// Card header container styles
export const cardHeaderStyles: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  mb: 2,
};

// Card header icon container styles
export const cardHeaderIconContainerStyles: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  gap: 1,
};

// Close icon button styles
export const closeIconButtonStyles: SxProps<Theme> = {
  color: "text.secondary",
};

// Loading container styles
export const loadingContainerStyles: SxProps<Theme> = {
  display: "flex",
  justifyContent: "center",
  py: 2,
};

// Accounts container styles
export const accountsContainerStyles: SxProps<Theme> = {
  ...settingsReportStyles.value,
  display: "flex",
  flexWrap: "wrap",
  gap: 0.5,
  mt: 0.5,
  alignItems: "center",
};

// Loading accounts box styles
export const loadingAccountsBoxStyles: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  gap: 1,
};

// Loading accounts text styles
export const loadingAccountsTextStyles: SxProps<Theme> = {
  color: "text.secondary",
};

// Empty accounts text styles
export const emptyAccountsTextStyles: SxProps<Theme> = {
  color: "text.secondary",
};

// Account tooltip container styles
export const accountTooltipContainerStyles: SxProps<Theme> = {
  p: 0.5,
};

// Selected account chip styles
export const selectedAccountChipStyles: SxProps<Theme> = {
  backgroundColor: "#E3F2FD",
  color: "#1976D2",
  cursor: "default",
  "& .MuiChip-deleteIcon": {
    color: "#1976D2",
    "&:hover": {
      color: "#1565C0",
    },
  },
  "&:hover": {
    backgroundColor: "#BBDEFB",
  },
};

// Deselected account chip styles
export const deselectedAccountChipStyles: SxProps<Theme> = {
  backgroundColor: "#E0E0E0",
  color: "#757575",
  cursor: "pointer",
  "&:hover": {
    backgroundColor: "#BDBDBD",
  },
};
